import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "barte-design-system";

import type { ModalImportRatesProps } from "./modal-import-rates.type";
import styles from "./modal-import-rates.module.css";

export const ModalImportRates = ({
    isOpen,
    onClose,
    isLoading,
    onHandleSubmit,
}: ModalImportRatesProps) => {
    const { t } = useTranslation();

    const [raw, setRaw] = useState<string>("");
    const [error, setError] = useState<string>("");

    const handleClose = () => {
        setRaw("");
        setError("");
        onClose();
    };

    const handleSave = () => {
        try {
            const parsed = JSON.parse(raw) as Record<string, any>;
            setError("");
            onHandleSubmit(parsed, handleClose);
        } catch {
            setError(t("payfac.pageRatesImportInvalidJson"));
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            title={t("payfac.pageRatesImportTitle")}
            onClose={handleClose}
            size="lg"
            footer={{
                primaryButton: {
                    children: t("payfac.pageRatesImportConfirmButton"),
                    onClick: handleSave,
                    disabled: !raw.trim(),
                    loading: isLoading,
                },
                secondaryButton: {
                    children: t("payfac.pageRatesModalCancelButton"),
                    variant: "outline",
                    onClick: handleClose,
                    disabled: isLoading,
                },
                buttonLayout: "hug",
            }}
        >
            <div className={styles.content}>
                <textarea
                    className={styles.textarea}
                    value={raw}
                    onChange={(e) => {
                        setRaw(e.target.value);
                        setError("");
                    }}
                    placeholder={t("payfac.pageRatesImportPlaceholder")}
                    spellCheck={false}
                />
                {error && <span className={styles.error}>{error}</span>}
            </div>
        </Modal>
    );
};
